// extracted by mini-css-extract-plugin
module.exports = {"modal":"Gdpr-module--modal--3FfR8"};